import {ElementRef, Injectable, Injector} from '@angular/core';
import {ConnectionPositionPair, Overlay, OverlayConfig, OverlayRef, PositionStrategy} from '@angular/cdk/overlay';
import {ComponentPortal, PortalInjector} from '@angular/cdk/portal';
import {McOverlayRef} from '../../core/models/mc-overlay-ref';

const ASIDE_CONFIG: IMCOverlayConfig = {
  width: '296px',
  height: '100%',
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-backdrop',
  position: [
    {
      originX: 'end',
      originY: 'center',
      overlayX: 'end',
      overlayY: 'center'
    }
  ]
};

const FULL_PANEL_CONFIG: IMCOverlayConfig = {
  width: '100%',
  height: '100%',
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-backdrop',
  position: [
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'center',
      overlayY: 'center'
    },
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'center',
      overlayY: 'center',
    },
  ]
};


@Injectable({ providedIn: 'root' })
export class OverlayService {
  public overlayRef: OverlayRef;
  protected _onCloseCallback: Function;
  constructor(private overlay: Overlay, private _injector: Injector) { }

  show(origin, component: any, injector: PortalInjector, onClose?: Function): OverlayRef {
    this.detach();
    this.createOverlay(origin, FULL_PANEL_CONFIG);
    const portal = new ComponentPortal(component, null, injector);
    this.overlayRef.attach(portal);
    this.overlayRef.getConfig();
    this.overlayRef.backdropClick().subscribe(() => this.hide());
    this._onCloseCallback = onClose ? onClose : undefined;
    return this.overlayRef;
  }

  showAside(origin, component: any, data: WeakMap<any, any>, onClose?: Function): OverlayRef {
    this.detach();
    const overlayRef = new McOverlayRef(this.createOverlay(origin, ASIDE_CONFIG));
    data.set(McOverlayRef, overlayRef);
    const portal = new ComponentPortal(component, null, new PortalInjector(this._injector, data));
    this.overlayRef.attach(portal);
    this.overlayRef.getConfig();
    this.overlayRef.backdropClick().subscribe(() => this.hide());
    this._onCloseCallback = onClose ? onClose : undefined;
    return this.overlayRef;
  }

  hide() {
    if (this._onCloseCallback) {
      this._onCloseCallback();
    }
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  protected createOverlay(origin, overlayConfig: IMCOverlayConfig): OverlayRef {
    const config = this.getOverlayConfig(origin, overlayConfig);
    this.overlayRef = this.overlay.create(config);
    return this.overlayRef;
  }

  protected detach() {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  private getOverlayConfig(origin, config: IMCOverlayConfig): OverlayConfig {
    return new OverlayConfig({
      width: config.width,
      height: config.height,
      hasBackdrop: config.hasBackdrop,
      positionStrategy: this.getOverlayPosition(origin, config),
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      backdropClass: config.backdropClass,
      disposeOnNavigation: false
    });
  }

  private getOverlayPosition(origin: ElementRef, config: IMCOverlayConfig): PositionStrategy {
    let positionStrategy;
    if (config.position.length) {
      positionStrategy = this.overlay.position()
        .flexibleConnectedTo(origin)
        .withPositions(config.position).withPush(false);
    } else {
      positionStrategy = this.overlay.position().flexibleConnectedTo(origin).withPositions( [

      ])
    }

    return positionStrategy;
  }

}
